import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../assets/css/variables.css";
import "../assets/css/Nav.css";
import logo from "../assets/images/logo.png";

const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Solutions", path: "/solutions" },
  { label: "Expertise", path: "/expertise" },
  { label: "About", path: "/about" },
  { label: "News & Events", path: "/news" },
  { label: "Careers", path: "/careers" },
  { label: "Locations", path: "/locations" },
];

export default function Nav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNav = (path) => {
    navigate(path);
    setMobileOpen(false);
    window.scrollTo(0, 0);
  };

  // Auto-close drawer on resize to desktop
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 768) setMobileOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <>
      <nav className="nav">
        {/* Logo — bigger, links to home */}
        <Link
          to="/"
          className="nav__logo"
          onClick={() => window.scrollTo(0, 0)}
        >
          <img src={logo} alt="Accelia Clinical Solutions" />
        </Link>

        {/* Desktop Links — right aligned via margin-left: auto in CSS */}
        <div className="nav__links">
          {NAV_LINKS.map(({ label, path }) => (
            <button
              key={path}
              className={`nav__link${location.pathname === path ? " active" : ""}`}
              onClick={() => handleNav(path)}
            >
              {label}
            </button>
          ))}
          <button
            className="nav__link nav__cta"
            onClick={() => handleNav("/contact")}
          >
            Contact Us
          </button>
        </div>

        {/* Hamburger — animated ☰ → × */}
        <button
          className={`nav__burger${mobileOpen ? " open" : ""}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle navigation"
          aria-expanded={mobileOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      {/* Mobile Drawer */}
      <div className={`nav__drawer${mobileOpen ? " open" : ""}`}>
        <div className="nav__drawer-inner">
          {NAV_LINKS.map(({ label, path }) => (
            <button
              key={path}
              className={`nav__drawer-link${location.pathname === path ? " active" : ""}`}
              onClick={() => handleNav(path)}
            >
              {label}
            </button>
          ))}
          <div className="nav__drawer-divider" />
          <button
            className="nav__drawer-cta"
            onClick={() => handleNav("/contact")}
          >
            Contact Us
          </button>
        </div>
      </div>
    </>
  );
}
